var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 4C12.001 3.44772 12.4487 3 13.001 3H19.001C19.5533 3 20.001 3.44772 20.001 4C20.001 4.55228 19.5533 5 19.001 5H13.001C12.4487 5 12.001 4.55228 12.001 4Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 7C12.001 6.44772 12.4487 6 13.001 6H16.001C16.5533 6 17.001 6.44772 17.001 7C17.001 7.55228 16.5533 8 16.001 8H13.001C12.4487 8 12.001 7.55228 12.001 7Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.501 2C5.80326 2 2.00098 5.80228 2.00098 10.5C2.00098 15.1977 5.80326 19 10.501 19C15.1987 19 19.001 15.1977 19.001 10.5C19.001 9.94771 19.4487 9.5 20.001 9.5C20.5533 9.5 21.001 9.94771 21.001 10.5C21.001 16.3023 16.3033 21 10.501 21C4.69869 21 0.000976562 16.3023 0.000976562 10.5C0.000976562 4.69772 4.69869 0 10.501 0C11.0533 0 11.501 0.447715 11.501 1C11.501 1.55228 11.0533 2 10.501 2Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2939 18.2929C18.6844 17.9024 19.3176 17.9024 19.7081 18.2929L21.7081 20.2929C22.0986 20.6834 22.0986 21.3166 21.7081 21.7071C21.3176 22.0976 20.6844 22.0976 20.2939 21.7071L18.2939 19.7071C17.9033 19.3166 17.9033 18.6834 18.2939 18.2929Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.ae1ab5d9c76cf2b4a88ea79dfd8ea166.svg";
export { ForwardRef as ReactComponent };